import { render, staticRenderFns } from "./404Page.vue?vue&type=template&id=8f4f57de&scoped=true"
import script from "./404Page.vue?vue&type=script&lang=js"
export * from "./404Page.vue?vue&type=script&lang=js"
import style0 from "./404Page.vue?vue&type=style&index=0&id=8f4f57de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4f57de",
  null
  
)

export default component.exports